module.exports = __webpack_public_path__ + "static/media/results_table_filters.b8ce7c23.png";